var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"notice"},[_vm._v(" "+_vm._s(_vm.$config.common.notice)+" ")]),_c('div',{staticClass:"licence decors-icons-mentions"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }